export const phone = /^((\+)|(00)|())([0-9]{9})$/

export const cif = /^[a-zA-Z][0-9]{8,12}$/

export const dni = /^[a-zA-Z]?[0-9]{8,9}[a-zA-Z]$/

export const multiple_email = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/

export const password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,}$/



// WEBPACK FOOTER //
// ./src/utils/regexps.ts